export default class PushSubscriptionError extends Error {
    constructor(message = '') {
        super(message);
    }
}
